import request from '@/utils/request'

// 本地调试baseURL调整
const baseURL = process.env.VUE_APP_BASE_API

// 获取自定义表单列表
export function getFormTable(data) {
  return request({
    url: '/customer_form/page',
    method: 'post',
    data,
    baseURL
  })
}

// 角色查询
export function getRoleList(data) {
  return request({
    url: '/role/queryList',
    method: 'post',
    data,
    baseURL
  })
}

// 新增表单
export function setFormTemplate(data) {
  return request({
    url: '/customer_form/save',
    method: 'post',
    data,
    baseURL
  })
}

// 删除数据字典
export function deleteForm(id) {
  return request({
    url: `/customer_form/${id}`,
    method: 'delete'
  })
}

// 分类
export function getFormTree(params) {
  return request({
    url: '/customer_form/tree',
    method: 'get',
    params
  })
}

// 表单详情
export function getFormDetail(id) {
  return request({
    url: `/customer_form/${id}`,
    method: 'get'
  })
}

// 编辑自定义表单
export function updateForm(data) {
  return request({
    url: `/customer_form`,
    method: 'put',
    data
  })
}
//  查询表单和多少流程关联 /customer_form/referenceCount
export function checkFormRelated(params) {
  return request({
    url: `/customer_form/referenceCount`,
    method: 'get',
    params
  })
}
// 查询审批类型
export function getProcessRules() {
  return request({
    url: '/processRule/list',
    method: 'get'
  })
}
// processKey查询我发起的流程列表
export function getProcessesByProcessKeys(data) {
  return request({
    url: '/taskManager/listProcessesByProcessKeys',
    method: 'post',
    data
  })
}
// 根据dataKeys查询流程列表
export function getProcessesByDataKeys(data) {
  return request({
    url: '/taskManager/listProcessesByDataKeys',
    method: 'post',
    data
  })
}
// 查询接口信息列表
export function getInterfaceInfoList() {
  return request({
    url: '/interface_info/list',
    method: 'get'
  })
}

// 系统变量获取
export function systemVariableList(params) {
  return request({
    url: `/customer_form/systemVariableList`,
    method: 'get',
    params
  })
}

// 系统变量数据获取
export function getSystemVariable(data) {
  return request({
    url: '/customer_form/systemVariables',
    method: 'post',
    data
  })
}

// 有编辑记录的字段列表
export function hasChangedLogColumns(params) {
  return request({
    url: '/dataChangeLog/hasChangeLogColumns',
    method: 'get',
    params
  })
}

// 编辑记录查询
export function dataChangeLogList(params) {
  return request({
    url: '/dataChangeLog/list',
    method: 'get',
    params
  })
}

// 流程状态获取
export function getProcessStatus(procInstId) {
  return request({
    url: `/approve/operate/getStatus/${procInstId}`,
    method: 'get'
  })
}

export function exclusiveList(params) {
  return request({
    url: '/interface_info/exclusive/list',
    method: 'get',
    params
  })
}
